import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, ToastController, AlertController } from 'ionic-angular';
import { Validators, FormBuilder } from '@angular/forms';
import { AuthData } from '../../providers/auth';
import { UserData } from '../../providers/user';
import { StorageFb } from '../../providers/storage';
import { EmailValidator } from '../../validators/email';
import * as firebase from 'firebase';

@Component({
  selector: 'user-register',
  templateUrl: 'user-register.html'
})
export class UserRegisterComponent {

  registerForm: any;
  registerData: any = false;
  imgTmp: any;
  registerPassword: String = '';
  submitAttempt: any = false;
  emailReadonly: any = true;
  origin: any;
  redirect: any;
  client: any;
  event: any;

  constructor(public navCtrl: NavController, public params: NavParams, formBuilder: FormBuilder, public auth: AuthData, public loading: LoadingController, public toastCtrl: ToastController, public st: StorageFb, public userProvider: UserData, public alertCtrl: AlertController) {

    this.client = this.params.get('client');
    this.event = this.params.get('event');
    this.origin = params.get('origin');
    this.redirect = params.get('redirect');

    // FORM ###################
    // Required fields
    this.registerForm = formBuilder.group({
      email: ['', Validators.compose([EmailValidator.isValid, Validators.required])],
      name: ['', Validators.compose([Validators.minLength(5), Validators.required])],
      photo: [''],
      networking: [''],
      terms: ['', Validators.required],
      // Other Data. If add or remove items, add or remove in the dataObject, dataForm and the template. No remove email.
      // You shoutd foresee the changes can affect the networking module
      telephone: ['', Validators.required],
      //identification: ['', Validators.compose([Validators.minLength(5), Validators.required])],
      company: ['', Validators.required],
      position: ['', Validators.required],
      offer: [''],
      need: ['']
    });

    // DATA ##################
    this.registerData = {
      email: '',
      name: '',
      photo: '',
      provider: '',
      networking: '',
      terms: '',
      uidProvider: '',
      uid: '',
      // Other Data. If add or remove items, add or remove in the dataObject, dataForm and the template. No remove email.
      // You shoutd foresee the changes can affect the networking module
      telephone: '',
      // identification: '',
      company: '',
      position: '',
      offer: '',
      need: ''
    };

    // The info is view in networking
    this.registerData.networkingData = {
      name: this.registerData.name,
      photo: this.registerData.photo,
      company: this.registerData.company,
      position: this.registerData.position,
      offer: this.registerData.offer,
      need: this.registerData.need,
      // Seach index data for networking
      search: this.registerData.name.toLowerCase() + ' ' +
      this.registerData.company.toLowerCase() + ' ' +
      this.registerData.position.toLowerCase()
    };

    console.log(this.origin);

    switch (this.origin) {
      case 'register':
        this.registerData.terms = true;
        this.registerData.networking = true;
        this.registerData.provider = 'password';
        break;
      case 'social-login-email':
        this.registerData.email = params.get('user').auth.email;
        this.registerData.uid = params.get('user').auth.uid;
        this.registerData.terms = true;
        this.registerData.networking = true;
        this.registerData.provider = 'password';
        this.registerData.uidProvider = params.get('user').auth.email;
        break;
      case 'social-login-facebook':
      case 'social-login-google':
      case 'social-login-twitter':
        this.registerData.email = params.get('user').providerData[0].email;
        this.registerData.name = params.get('user').providerData[0].displayName;
        this.registerData.photo = params.get('user').providerData[0].photoURL;
        this.registerData.uid = params.get('user').uid;
        this.registerData.terms = true;
        this.registerData.networking = true;
        this.registerData.provider = params.get('user').providerData[0].providerId;
        this.registerData.uidProvider = params.get('user').providerData[0].uid;
        break;
      case 'event-profile':
        this.registerData.email = params.get('user').providerData[0].email;
        this.registerData.name = params.get('user').providerData[0].displayName;
        this.registerData.photo = params.get('user').providerData[0].photoURL;
        this.registerData.uid = params.get('user').uid;
        this.registerData.terms = true;
        this.registerData.networking = true;
        this.registerData.provider = params.get('user').providerData[0].providerId;
        this.registerData.uidProvider = params.get('user').providerData[0].uid;

        if (this.registerData.email) {
          this.emailReadonly = true;
        }
        break;
      case 'event-profile-edit':
        this.registerData = params.get('user');
        break;
    }
  }

  onTermsChecked($event) {
    if (!$event.checked) {
      this.registerData.terms = null;
      this.registerForm.patchValue({ terms: null });
    }
  }

  save() {
    this.submitAttempt = true;

    if (this.registerForm.valid) {
      if (!this.registerData.networking) {
        let alert = this.alertCtrl.create({
          title: 'Información del usuario',
          message: '¿Está seguro que no desea hacer parte del networking de Rebus?',
          buttons: [
            {
              text: 'Cancelar',
              role: 'cancel',
            },
            {
              text: 'Estoy seguro',
              handler: () => {
                if (this.origin == 'register') {
                  this.verifiedPassword();
                } else {
                  this.verifiedImage();
                }
              }
            }
          ]
        });
        alert.present();
      } else {
        if (this.origin == 'register') {
          this.verifiedPassword();
        } else {
          this.verifiedImage();
        }
      }
    }
  }

  verifiedPassword() {
    let alert2 = this.alertCtrl.create({
      title: 'Registro de usuario',
      message: 'Ingresa una contraseña: ',
      inputs: [
        {
          name: 'password',
          placeholder: 'Contraseña',
          type: 'password'
        }
      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
        },
        {
          text: 'Finalizar',
          handler: (data) => {
            if (this.isValidPassword(data.password)) {
              this.registerPassword = data.password;
              this.verifiedImage();
            } else {
              data.password = '';
              return false;
            }
          }
        }
      ]
    });

    alert2.present();
  }

  verifiedImage() {
    // Search image upload
    if (this.imgTmp) {
      let loader = this.loading.create({
        content: "Cargando imagen..."
      });
      loader.present();
      this.st.uploadAvatar(this.client, this.imgTmp).then((success: any) => {
        this.registerData.photo = success.a.downloadURLs[0];
        this.create(loader);
      });
    } else {
      this.create(false);
    }
  }

  create(loaderOld: any = false) {
    let loader = this.loading.create({
      content: "Verificando la información del usuario"
    });

    loader.present();

    if (loaderOld) {
      loaderOld.dismiss();
    }

    if (this.origin == 'social-login-twitter') {
      // Se debe actualizar el correo
      let user = firebase.auth().currentUser;

      user.updateEmail(this.registerData.email).then(() => {
        if (this.origin == 'register') {
          this.auth.linkAccount(this.registerData.email, this.registerPassword)
            .then((user) => {
              this.registerData.uidProvider = this.registerData.email;
              this.registerData.uid = user.uid;

              this.endCreate(loader);
            })
            .catch((error: any) => {
              this.errorMessageFilter(error, loader);
            })
        } else {
          this.endCreate(loader);
        }
      }, (error) => {
        console.log(error, loader)
        this.errorMessageFilter(error, loader);
        this.registerData.email = '';
      });
    } else {
      if (this.origin == 'register') {
        this.auth.linkAccount(this.registerData.email, this.registerPassword)
          .then((user) => {
            this.registerData.uidProvider = this.registerData.email;
            this.registerData.uid = user.uid;

            this.endCreate(loader);
          })
          .catch((error: any) => {
            this.errorMessageFilter(error, loader);
          })
      } else {
        this.endCreate(loader);
      }
    }
  }

  errorMessageFilter(error, loader) {
    let msg: any;

    switch (error.code) {
      case 'auth/invalid-email':
        msg = 'Correo electrónico inválido';
        this.registerForm.patchValue({ email: '' });
        this.registerPassword = '';
        // this.registerForm.patchValue({ password: '' });
        break;
      case 'auth/weak-password':
        msg = 'La contraseña debe contener mínimo 6 caracteres';
        this.registerForm.patchValue({ password: '' });
        this.registerPassword = '';
        break;
      case 'auth/email-already-in-use':
        msg = 'EL correo electrónico ya se encuentra en uso. Por favor inicie sesión';
        this.registerForm.patchValue({ email: '' });
        this.registerPassword = '';
        break;
      default:
        msg = 'Se ha presentado un error interno. Póngase en contacto con el administrador';
        this.registerForm.patchValue({ email: '' });
        this.registerPassword = '';
        break;
    }

    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000
    });
    loader.dismiss();
    toast.present();
  }

  endCreate(loader) {
    // Update networking
    this.registerData.networkingData = {
      name: this.registerData.name,
      photo: this.registerData.photo,
      company: this.registerData.company,
      position: this.registerData.position,
      offer: this.registerData.offer,
      need: this.registerData.need,
      // Seach index data for networking
      search: this.registerData.name.toLowerCase() + ' ' +
      this.registerData.company.toLowerCase() + ' ' +
      this.registerData.position.toLowerCase()
    };

    this.userProvider.endRegister(this.client, this.registerData, this.params.get('user') || this.auth.getUser())
      .then((data) => {
        let msg: any;

        switch (this.origin) {
          case 'event-profile':
            msg = 'Usuario actualizado correctamente';
            break;
          case 'social-login-email':
          case 'social-login-facebook':
          case 'social-login-google':
          case 'social-login-twitter':
            msg = 'Ha iniciado se sesión como ' + this.registerData.name;
            break;
          case 'register':
            msg = 'Ha quedado registrado correctamente';
            break;
        }

        let toast = this.toastCtrl.create({
          message: msg,
          position: 'top',
          showCloseButton: true,
          closeButtonText: 'ok',
          duration: 5000
        });
        loader.dismiss();
        toast.present();
        this.registerForm.reset();
        this.imgTmp = null;

        if (this.redirect == 'event') {
          // TODO: rediect review
        } else {
          this.navCtrl.pop();
        }
      })
      .catch(error => {
        let toast = this.toastCtrl.create({
          message: error,
          duration: 5000
        });
        loader.dismiss();
        toast.present();
      });
  }

  isValidPassword(pass) {
    if (pass) {
      if (pass.length > 5) {
        return true;
      } else {
        let toast = this.toastCtrl.create({
          message: 'La contraseña debe contener mínimo 6 caracteres',
          duration: 5000
        });

        toast.present();
      }
    }

    return false;
  }

  generateFile(fileInput) {
    this.imgTmp = null;
    this.imgTmp = fileInput.target.files[0];
  }

  elementChanged(input) {
    let field = input.inputControl.name;
    this[field + "Changed"] = true;
  }
}
// TODO: review register
// TODO: preview image change
// TODO: depending type redirect in endCreate
// TODO: emailReadonly for social login form and edit form
// TODO: end where abandoned register form
// TODO: Telephone validator
// end file



// WEBPACK FOOTER //
// ./src/components/user-register/user-register.ts